/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toolbar[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}.toolbar[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin:5px}.PuDo-warning[_ngcontent-%COMP%]{color:#ff4500}[_nghost-%COMP%]     .cell-locked{color:#8a2be2}[_nghost-%COMP%]     .allow-edit{-webkit-text-decoration:underline dotted #4169e1;text-decoration:underline dotted #4169e1;text-underline-offset:4px}"];
export { styles as styles };
